import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  Table,
  Tag,
  Button,
  Space,
  Typography,
  Row,
  Col,
  Statistic,
  Modal,
  Form,
  Select,
  Input,
  notification,
  Tooltip,
  Divider,
  Alert,
} from "antd";
import {
  CalendarOutlined,
  WhatsAppOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  EyeOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { AppContext } from "../context/AppContext";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

// Zambian theme colors
const ZAMBIA_THEME = {
  primary: "#078930",
  secondary: "#EF3340",
  accent: "#FFB81C",
  neutral: "#2D2D2D",
};

const DemoBookings = () => {
  const token = localStorage.getItem("token");
  const [demoBookings, setDemoBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [statusModalVisible, setStatusModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { company } = useContext(AppContext);

  useEffect(() => {
    fetchDemoBookings();
  }, []);

  const fetchDemoBookings = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://zedlenders.pickmesms.com/items/demo_bookings?sort=-created_at`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDemoBookings(response.data.data || []);
    } catch (err) {
      console.error("Error fetching demo bookings:", err);
      if (err.response?.status === 403) {
        setError(
          "Collection 'demo_bookings' not found. Please create it in Directus first."
        );
      } else {
        setError("Failed to fetch demo bookings");
      }
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <div style={{ maxWidth: 1400, margin: "0 auto", padding: "0 24px" }}>
        <Card>
          <Title
            level={2}
            style={{ color: ZAMBIA_THEME.primary, marginBottom: 24 }}
          >
            Demo Booking Management
          </Title>

          <Alert
            message="Collection Not Found"
            description={
              <div>
                <p>{error}</p>
                <p>
                  <strong>
                    To create the demo_bookings collection in Directus:
                  </strong>
                </p>
                <ol>
                  <li>Go to your Directus admin panel</li>
                  <li>Navigate to Settings → Data Model</li>
                  <li>Create a new collection called "demo_bookings"</li>
                  <li>Add these fields:</li>
                  <ul>
                    <li>
                      <code>full_name</code> (String)
                    </li>
                    <li>
                      <code>email</code> (String)
                    </li>
                    <li>
                      <code>whatsapp_number</code> (String)
                    </li>
                    <li>
                      <code>company_name</code> (String)
                    </li>
                    <li>
                      <code>company_type</code> (String)
                    </li>
                    <li>
                      <code>preferred_date</code> (Date)
                    </li>
                    <li>
                      <code>preferred_time</code> (String)
                    </li>
                    <li>
                      <code>notes</code> (Text, Optional)
                    </li>
                    <li>
                      <code>status</code> (String, Default: "pending")
                    </li>
                    <li>
                      <code>admin_notes</code> (Text, Optional)
                    </li>
                    <li>
                      <code>created_at</code> (DateTime)
                    </li>
                    <li>
                      <code>updated_at</code> (DateTime)
                    </li>
                  </ul>
                </ol>
              </div>
            }
            type="warning"
            icon={<ExclamationCircleOutlined />}
            showIcon
            style={{ marginBottom: 24 }}
          />

          <Button
            type="primary"
            onClick={fetchDemoBookings}
            style={{
              backgroundColor: ZAMBIA_THEME.primary,
              borderColor: ZAMBIA_THEME.primary,
            }}
          >
            Try Again
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1400, margin: "0 auto", padding: "0 24px" }}>
      <Card>
        <Title level={2} style={{ color: ZAMBIA_THEME.primary }}>
          Demo Booking Management
        </Title>
        <Text>
          No demo bookings found. Once you create the collection, bookings will
          appear here.
        </Text>
      </Card>
    </div>
  );
};

export default DemoBookings;
